export const isValidKINumber = (value: string) => value !== '' && /^[a-zA-Z]([a-zA-Z]|\d)\d\d[a-zA-Z]\d\d$/.test(value)
